import { useState } from 'react';
import HistoryTask from './HistoryTask';
import DiagramTask from './DiagramTask';
import DetailTask from './DetailTask';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function TabGroupTask({ taskDetail }: { taskDetail: any }) {
  const [activeTab, setActiveTab] = useState('diagram');
  const activeClassName = `text-main-blue-alurkerja bg-blue-50 border-b border-main-blue-alurkerja`;

  const handleClickTab = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="tab-group">
      {/* tab */}
      <span className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-y border-gray-200">
        <button className="me-2" onClick={() => handleClickTab('detail')}>
          <span
            className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
              activeTab === 'detail' ? activeClassName : ''
            }`}
          >
            Detail
          </span>
        </button>
        <button className="me-2" onClick={() => handleClickTab('history')}>
          <span
            className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
              activeTab === 'history' ? activeClassName : ''
            }`}
          >
            History
          </span>
        </button>
        <button className="me-2" onClick={() => handleClickTab('diagram')}>
          <span
            className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
              activeTab === 'diagram' ? activeClassName : ''
            }`}
          >
            Diagram
          </span>
        </button>
      </span>

      {/* tab content */}
      <div className="p-4">
        <DetailTask show={activeTab === 'detail'} taskDetail={taskDetail} />

        <HistoryTask show={activeTab === 'history'} history={taskDetail?.instance_history} />

        <DiagramTask
          show={activeTab === 'diagram'}
          processKey={taskDetail?.process_definition_id}
          taskKey={taskDetail?.task_definition_key}
        />
      </div>
    </div>
  );
}
